import { lazy } from 'react';
import { authRoles } from 'app/auth';

const TrainingAndGuidesPage = lazy(() => import('./TrainingAndGuidesPage'));

const TrainingAndGuidesConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'featured',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'training-and-guides',
      element: <TrainingAndGuidesPage />,
    },
  ],
};

export default TrainingAndGuidesConfig;
